import { Injectable } from '@angular/core';
import {
  Observable,
  ReplaySubject,
  fromEvent as observableFromEvent,
} from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

export interface WindowSize {
  width: number;
  height: number;
}

@Injectable()
export class WindowResizeService {
  private windowResizedSubject = new ReplaySubject<WindowSize>(1);
  windowResized$ = this.windowResizedSubject.asObservable();

  constructor() {
    observableFromEvent(window, 'resize')
      .pipe(
        map(() => {
          return { width: window.innerWidth, height: window.innerHeight };
        }),
        distinctUntilChanged(),
      )
      .subscribe(this.windowResizedSubject);
  }

  windowResized(): Observable<WindowSize> {
    return this.windowResized$;
  }
}
